module.exports = __webpack_public_path__ + "img/fb-icon.c429af04.svg";